export type HoverCardType = 'poi' | 'poiCluster' | 'pipeline' | 'fitting' | 'airvalve' | 'van';

/**
 * Order of precedence, highest first. At most one hover card is ever shown; when several are
 * active at once the first match in this list wins. POI and air-valve are mode-gated (Find &
 * Fix vs SAVI) so they never co-occur. An individual POI pin beats the cluster circle behind
 * it — the pin is the thing the cursor is actually over. Vans sit above POIs after clusters:
 * a van marker draws in assetOverlays beneath the POI pins, so a pin over a van wins, but the
 * van (a discrete moving marker) beats the fittings and pipes it drives over. Fitting beats
 * pipeline: fittings are small point features and the pipe runs underneath them on both
 * sides, so the fitting is the thing the cursor is actually over.
 */
const HOVER_CARD_PRECEDENCE: HoverCardType[] = ['poi', 'airvalve', 'poiCluster', 'van', 'fitting', 'pipeline'];

/**
 * Picks the single highest-precedence hover card from those currently active. Each card now
 * positions itself via its own MapLibre `<Popup>`, so the only shared decision left is which one
 * wins when several features are hovered at once. Returns null when none are active.
 */
export function pickHoverCard(active: HoverCardType[]): HoverCardType | null {
    return HOVER_CARD_PRECEDENCE.find((id) => active.includes(id)) ?? null;
}
